import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

import { HttpService } from '../http.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private httpService: HttpService,
              private router: Router) { }

  private servicePath = 'service';

  public jobOnsite = '1';
  public jobParts = '4';
  public jobRemote = '2';
  public jobGeekCoverRemote = '3';
  public completeStatus = 'completed';
  public cancelledStatus = 'cancelled';
  public openStatus = 'open';

  getService(serviceID): Observable<any>{
    return this.httpService.httpGet(this.servicePath + '/' + serviceID).pipe(response => {
      return response;
    });
  }
}
